<template>
  <div :key="containerKey">
    <header-wrap></header-wrap>
    <secord-nav></secord-nav>

    <!-- big title -->
    <div class="area_title">
      <h1>{{ productProgramPage.title }}</h1>
      <div class="breadcrumb_wrap">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">{{ navbar.home }}</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span class="is-link" @click="toPath()">{{ productProgramPage.title }}</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item v-if="activeNameText !== ''">{{
            activeNameText
          }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>

    <!-- tab栏&tab栏内容 -->
    <div class="area_cation">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane :label="productProgramPage.tabs[0]" name="1">
          <div class="zp_wrap">
            <h2>{{ productApplication.title }}</h2>
            <p>
              {{ productApplication.content }}
            </p>
          </div>
          <div class="area_every">
            <template v-for="(item, index) in oneList">
              <div class="area_li" v-if="index % 2 === 0">
                <div class="area_wrap">
                  <img :src="item.image" alt="" />
                  <div class="li_right">
                    <h2>{{ item[`${currentLang.prefix}title`] }}</h2>
                    <p>
                      {{ item[`${currentLang.prefix}summary`] }}
                    </p>
                    <div class="dynamic_btn" @click="goDetail(item, activeName, activeNameText, 1)">
                      <span>MORE</span>
                      <img class="more_btn" src="../../assets/images/public/arrow1.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="area_li" v-if="index % 2 === 1">
                <div class="area_wrap">
                  <div class="li_left">
                    <div class="left_box">
                      <h2>{{ item[`${currentLang.prefix}title`] }}</h2>
                      <p>
                        {{ item[`${currentLang.prefix}summary`] }}
                      </p>
                      <div class="dynamic_btn" @click="goDetail(item, activeName, activeNameText, 1)">
                        <span>MORE</span>
                        <img class="more_btn" src="../../assets/images/public/arrow1.png" alt="" />
                      </div>
                    </div>
                  </div>
                  <img :src="item.image" alt="" />
                </div>
              </div>
            </template>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="productProgramPage.tabs[1]" name="2">
          <div class="zp_wrap">
            <h2>{{ solution.title }}</h2>
            <p>
              {{ solution.content }}
            </p>
          </div>
          <div class="fa_two">
            <div class="two_top">
              <span v-for="(item, index) in twoList" :key="item.id" @click="goDetail(item, activeName, activeNameText, 1)">

                <img
                  :src="'https://miniapp.kelkflow.com' + item.ico_image"
                  alt=""
                  class="fa_two-icon"
                />
                <p>{{ item[`${currentLang.prefix}title`] }}</p>
              </span>

            </div>
          </div>
          <div class="area_every">
            <template v-for="(item, index) in twoList">
              <div class="area_li" v-if="index % 2 === 0">
                <div class="area_wrap">
                  <img :src="item.image" alt="" />
                  <div class="li_right">
                    <h2>{{ item[`${currentLang.prefix}title`] }}</h2>
                    <p>
                      {{ item[`${currentLang.prefix}summary`] }}
                    </p>
                    <div class="dynamic_btn" @click="goDetail(item, activeName, activeNameText, 1)">
                      <span>MORE</span>
                      <img class="more_btn" src="../../assets/images/public/arrow1.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="area_li" v-if="index % 2 === 1">
                <div class="area_wrap">
                  <div class="li_left">
                    <div class="left_box">
                      <h2>{{ item[`${currentLang.prefix}title`] }}</h2>
                      <p>
                        {{ item[`${currentLang.prefix}summary`] }}
                      </p>
                      <div class="dynamic_btn" @click="goDetail(item, activeName, activeNameText, 1)">
                        <span>MORE</span>
                        <img class="more_btn" src="../../assets/images/public/arrow1.png" alt="" />
                      </div>
                    </div>
                  </div>
                  <img :src="item.image" alt="" />
                </div>
              </div>
            </template>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="productProgramPage.tabs[2]" name="3">
          <div class="cate-tag__box" v-if="cateList && cateList.length > 0">
            <el-tag
              v-for="(item, index) in cateList"
              :key="index"
              effect="plain"
              type="info"
              class="cate-tag"
              :class="activeCate == item.id ? 'cate-tag--active' : ''"
              @click="onTagClick(item.id)"
            >{{ item[`${currentLang.prefix}name`] }}</el-tag>
          </div>
          <div
          class="xc_wrap"
          :data-masonry='`{ "itemSelector": ".grid-item", "columnWidth": ${gridItemSize} }`'
          >
            <div class="grid-item" v-for="item in threeList" :key="item.id" ref="gridItemRef">
              <img :src="item.image" alt="" class="n_img" />
              <div class="news_title">{{ item[`${currentLang.prefix}title`] }}</div>
              <p class="create-time">
                <span>{{ item.publish_time_txt ? item.publish_time_txt.split(' ')[0] : "" }}</span>
              </p>
              <!-- <div @click="goNdetail(item.id)" class="dynamic_btn"> -->
              <div @click="goDetail(item, activeName, activeNameText)" class="dynamic_btn">
                <span>MORE</span>
                <img class="more_btn" src="../../assets/images/public/arrow1.png" alt="" />
              </div>
            </div>
          </div>
          <div class="sc_pagi" v-if="total !== 0">
            <el-pagination background layout="prev, pager, next" :page-size="15" :total="total"
              @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="productProgramPage.tabs[3]" name="4">
          <div class="cate-tag__box" v-if="cateList && cateList.length > 0">
            <el-tag
              v-for="(item, index) in cateList"
              :key="index"
              effect="plain"
              type="info"
              class="cate-tag"
              :class="activeCate == item.id ? 'cate-tag--active' : ''"
              @click="onTagClick(item.id)"
            >{{ item[`${currentLang.prefix}name`] }}</el-tag>
          </div>
          <div
          class="xc_wrap1"
          :data-masonry='`{ "itemSelector": ".grid-item1", "columnWidth": ${gridItemSize1} }`'>
            <div class="grid-item1" v-for="item in fourList" :key="item.id" ref="gridItem1Ref">
              <img :src="item.image" alt="" class="n_img" />
              <div class="news_title">{{ item[`${currentLang.prefix}title`] }}</div>
              <p class="create-time">
                <span>{{ item.publish_time_txt ? item.publish_time_txt.split(' ')[0] : "" }}</span>
              </p>
              <!-- <div @click="goNdetail(item.id)" class="dynamic_btn"> -->
              <div @click="goDetail(item, activeName, activeNameText)" class="dynamic_btn">
                <span>MORE</span>
                <img class="more_btn" src="../../assets/images/public/arrow1.png" alt="" />
              </div>
            </div>
          </div>
          <div class="sc_pagi" v-if="total !== 0">
            <el-pagination background layout="prev, pager, next" :page-size="15" :total="total"
              @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <block v-show="activeName === '0'">

      <div class="zp_wrap">
        <h2>{{ productProgramPage.subTitle }}</h2>
        <p>
          {{ detailsInfo[`${currentLang.prefix}summary`] }}
        </p>
      </div>

      <!-- one -->
      <div class="cp_two cp_item" style="display: flex;background: #f5f5f5;">
        <div class="two_fir">
          <div style="width: 45%;">
            <div class="one_tit">
              <img src="../../assets/images/icons/product-apply.png" alt="" />
              {{ productProgramPage.tabs[0] }}
            </div>
            <div class="one_ul">
              <span class="li_line"></span>
              <div class="one_li" v-for="(item, index) in oneList" :key="item.id" v-if="index < 5"
                @click="goDetail(item, activeName, productProgramPage.tabs[0], 1)">
                <div style="display: flex;align-items:center;color: #545454;">
                  <span class="menu_single">
                    <img src="../../assets/images/icons/product-apply.png" alt="" />
                  </span>
                  <span>{{ item[`${currentLang.prefix}title`] }}</span>
                </div>
                <img src="../../assets/images/cpzy/i27.png" alt="" />
              </div>
            </div>
            <div class="dynamic_btn" @click="goXczl('1')">
              <span>MORE</span>
              <img class="more_btn" src="../../assets/images/public/arrow1.png" alt="" />
            </div>
          </div>
          <div class="two_bg">
            <img src="../../assets/images1/i44.png" alt="" style="transform: scale(0.9);" />
          </div>
        </div>
      </div>

      <!-- two -->
      <div class="cp_two cp_item" style="background: white;">
        <div class="two_fir">
          <div class="two_bg">
            <img src="../../assets/images1/i45.png" />
          </div>
          <div style="width: 45%;">
            <div class="one_tit">
              <img src="../../assets/images/icons/jiejuefangan.png" alt="" />
              {{ productProgramPage.tabs[1] }}
            </div>
            <div class="one_ul">
              <span class="li_line"></span>
              <div class="one_li" v-for="(item, index) in twoList" :key="item.id" v-if="index < 5"
                @click="goDetail(item, activeName, productProgramPage.tabs[1], 1)">
                <div style="display: flex;align-items:center;color: #545454;">
                  <span class="menu_single">
                    <img src="../../assets/images/icons/jiejuefangan.png" alt="" />
                  </span>
                  <span>{{ item[`${currentLang.prefix}title`] }}</span>
                </div>
                <img src="../../assets/images/cpzy/i27.png" alt="" />
              </div>
            </div>
            <div class="dynamic_btn" @click="goXczl('2')">
              <span>MORE</span>
              <img class="more_btn" src="../../assets/images/public/arrow1.png" alt="" />
            </div>
          </div>
        </div>
      </div>

      <img style="width: 100%;" src="../../assets/images1/i46.jpg" alt="" />
      
      <div class="cp_one">
        <div style="width: 45%;">
          <div class="one_tit">
            <img src="../../assets/images/icons/product-anlie.png" alt="" />
            {{ productProgramPage.tabs[2] }}
          </div>
          <div class="one_ul">
            <span class="li_line"></span>
            <div class="one_li" v-for="(item, index) in threeList" :key="item.id" v-if="index < 5"
              @click="goDetail(item, activeName, productProgramPage.tabs[2])">
              <div style="display: flex;align-items:center;color: #545454;">
                <span class="menu_single">
                  <img src="../../assets/images/icons/product-anlie.png" alt="" />
                </span>
                <span>{{ item[`${currentLang.prefix}title`] }}</span>
              </div>
              <img src="../../assets/images/cpzy/i27.png" alt="" />
            </div>
          </div>
          <div class="dynamic_btn" @click="goXczl('3')">
            <span>MORE</span>
            <img class="more_btn" src="../../assets/images/public/arrow1.png" alt="" />
          </div>
        </div>
        <div style="width: 45%;">
          <div class="one_tit">
            <img src="../../assets/images/icons/fault_type.png" alt="" />
            {{ productProgramPage.tabs[3] }}
          </div>
          <div class="one_ul">
            <span class="li_line"></span>
            <div class="one_li" v-for="(item, index) in fourList" :key="item.id" v-if="index < 5"
              @click="goDetail(item, activeName, productProgramPage.tabs[3])">
              <div style="display: flex;align-items:center;color: #545454;">
                <span class="menu_single">
                  <img src="../../assets/images/icons/fault_type.png" alt="" />
                </span>
                <span>{{ item[`${currentLang.prefix}title`] }}</span>
              </div>
              <img src="../../assets/images/cpzy/i27.png" alt="" />
            </div>
          </div>
          <div class="dynamic_btn" @click="goXczl('4')">
            <span>MORE</span>
            <img class="more_btn" src="../../assets/images/public/arrow1.png" alt="" />
          </div>
        </div>
      </div>
    </block>
    <footer-wrap></footer-wrap>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getCateDetailInfo, getCaseList } from "@/utils/http.js";
import Masonry from "masonry-layout";
export default {
  inject: ['reload'],

  data() {
    return {
      cateList: [],
      activeCate: '',

      activeName: "0",
      activeNameText: "",
      oneList: [],
      twoList: [],
      threeList: [],
      fourList: [],
      detailsInfo: {},
      total: 0,
      page: 1,
      gridItemSize: 400,
      gridItemSize1: 400,
      debounceTimer: null,
      containerKey: 0,
    };
  },

  computed: {
    ...mapGetters([
      'currentLang'
    ]),
    productProgramPage() {
      return this.currentLang.config.productProgramPage
    },
    productApplication() {
      return this.currentLang.config.productProgramPage.productApplication
    },
    solution() {
      return this.currentLang.config.productProgramPage.solution
    },
    productCase() {
      return this.currentLang.config.productProgramPage.productCase
    },
    maintenanceCase() {
      return this.currentLang.config.productProgramPage.maintenanceCase
    },
    navbar() {
      return this.currentLang.config.navbar
    },
  },

  created() {
    if (this.$route.query.index) {
      this.activeName = this.$route.query.index
      this.setNavActiveNameText(this.activeName)
    }

    if (this.activeName == '0') {
      this.getDetails();
      this.getNewList1();
      this.getNewList2();
      this.getNewList3();
      this.getNewList4();
    }
    if (this.activeName == '1') {
      this.getNewList1();
    }
    if (this.activeName == '2') {
      this.getNewList2();
    }
    if (this.activeName == '3') {
      this.getNewList3();
    }
    if (this.activeName == '4') {
      this.getNewList4();
    }
  },

  updated() {
    this.handleMasonry()
  },

  mounted() {
    this.handleMasonry()
    window.addEventListener('resize', this.handleResize);
  },

  methods: {
    onTagClick(val) {
      this.activeCate = val
      this.handleCurrentChange(1)
    },

    handleResize() {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
        this.debounceTimer = null
      }
      this.debounceTimer = setTimeout(() => {
        if (this.activeName > 2) {
          // this.$router.go(0)
          this.handleMasonry().then(() => {
            this.containerKey += 1
          })
        }
      }, 50)
    },

    handleMasonry() {
      return new Promise((resolve) => {
        this.$nextTick(() => {
          let size = 0
          let size1 = 0
          if (this.$refs.gridItemRef && this.$refs.gridItemRef.length > 0) {
            let info = this.$refs.gridItemRef[0]
            let styleInfo = window.getComputedStyle(info)
            size = info.clientWidth + (styleInfo.marginRight.replace('px', '') - 0)
          }
          if (this.$refs.gridItem1Ref && this.$refs.gridItem1Ref.length > 0) {
            let info = this.$refs.gridItem1Ref[0]
            let styleInfo = window.getComputedStyle(info)
            size1 = info.clientWidth + (styleInfo.marginRight.replace('px', '') - 0)
          }
          
          this.gridItemSize = size > 0 ? size : 400
          const grid = document.querySelector(".xc_wrap");
          const msnry = new Masonry(grid, {
            // options...
            itemSelector: ".grid-item",
            // columnWidth: 400,
            columnWidth: size > 0 ? size : 400
          });
          
          this.gridItemSize1 = size1 > 0 ? size1 : 400
          const grid1 = document.querySelector(".xc_wrap1");
          const msnry1 = new Masonry(grid1, {
            // options...
            itemSelector: ".grid-item1",
            // columnWidth: 400,
            columnWidth: size1 > 0 ? size1 : 400
          });

          resolve()
        })
      })
    },


    setNavActiveNameText(active) {
      const { tabs } = this.productProgramPage
      switch(active) {
        case '1': this.activeNameText = tabs[0];break;
        case '2': this.activeNameText = tabs[1];break;
        case '3': this.activeNameText = tabs[2];break;
        case '4': this.activeNameText = tabs[3];break;
      }
    },

    toPath() {
      this.$router.push('/cpProgram')
      this.reload()
    },

    getDetails() {
      getCateDetailInfo({ cate_id: 22 }).then(res => {
        if (res.code === 1) {
          this.detailsInfo = res.data;
        }
      });
    },
    getNewList1() {
      getCaseList({
        cate_id: 23,
        page: 1,
        limit: 12
      }).then(res => {
        console.log(res);
        if (res.code === 1) {
          this.oneList = res.data.list;
        }
      });
    },
    getNewList2() {
      getCaseList({
        cate_id: 31,
        page: 1,
        limit: 12
      }).then(res => {
        console.log(res);
        if (res.code === 1) {
          this.twoList = res.data.list;
        }
      });
    },
    getNewList3() {
      getCaseList({
        cate_id: 75,
        page: this.page,
        limit: 15,
        type_id: this.activeCate,
      }).then(res => {
        // console.log('resres',res);
        if (res.code === 1) {
          this.total = res.data.count;
          this.threeList = res.data.list;
          this.cateList = res.data.type_info ? [
            { name: this.productCase.tagListAll[0].name, id: this.productCase.tagListAll[0].id },
            ...res.data.type_info
          ] : []
        }
      });
    },
    getNewList4() {
      getCaseList({
        cate_id: 76,
        page: this.page,
        limit: 15,
        type_id: this.activeCate,
      }).then(res => {
        // console.log(res);
        if (res.code === 1) {
          this.total = res.data.count;
          this.fourList = res.data.list;
          this.cateList = res.data.type_info ? [
            { name: this.maintenanceCase.tagListAll[0].name, id: this.maintenanceCase.tagListAll[0].id },
            ...res.data.type_info
          ] : [];
        }
      });
    },
    goNdetail(id) {
      this.$router.push({ path: "/nText", query: { id: id, activeNameText: this.activeNameText } });
    },
    handleClick(tab) {
      this.activeNameText = tab.label;
      this.$router.push({
        path: '/cpProgram',
        query: {
          index: this.activeName,
        }
      })
      this.reload()
      /* if (this.activeName === '1') {
        this.getNewList1();
      }
      if (this.activeName === '2') {
        this.getNewList2();
      }
      if (this.activeName === '3') {

        this.getNewList3();
      }
      if (this.activeName === '4') {

        this.getNewList4();
      } */
    },
    goXczl(index) {
      this.activeName = index;
      this.activeNameText = this.productProgramPage.tabs[index - 1]
      this.$router.push({
        path: '/cpProgram',
        query: {
          index: this.activeName,
        }
      })
      this.reload()
      /* if (this.activeName === '1') {
        this.getNewList1();
      }
      if (this.activeName === '2') {
        this.getNewList2();
      }
      if (this.activeName === '3') {

        this.getNewList3();
      }
      if (this.activeName === '4') {

        this.getNewList4();
      } */
    },
    handleCurrentChange(val) {
      this.page = val
      if (this.activeName === '3') {

        this.getNewList3();
      }
      if (this.activeName === '4') {

        this.getNewList4();
      }
    },
    goDetail(info, name, nameTxt, byFrom) {
      this.$router.push({
        path: "/programDetail",
        query: { id: info.id, activeName: name, activeNameText: nameTxt, from: byFrom ? byFrom : '' }
      });
    },
  },
  
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style lang="scss" scoped>

.cate-tag__box {
  width: 1200px;
  margin: 30px auto;
  padding-bottom: 10px;

  .cate-tag {
    margin-right: 10px;
    cursor: pointer;
    background-color: var(--main-color-blue);
    background-color: #c0c4cc;
    border-color: transparent;
    border-radius: 20px;
    color: #000;
    font-size: 16px;
    transition: all 0.3s;
  }

  .cate-tag:hover,
  .cate-tag--active {
    background-color: var(--main-color-blue);
    color: #fff;
  }
}





.area_title {
  width: 100%;
  height: 160px;
  line-height: 160px;
  background: url("../../assets/images/public/i12.jpg") no-repeat;
  background-size: 100% 100%;
  background-size: cover;
  background-position: center center;
  text-align: center;
  position: relative;

  h1 {
    color: white;
    font-weight: normal;
  }

  .breadcrumb_wrap {
    width: 1200px;
    position: absolute;
    top: 15px;
    left: calc(50% - 600px);

    /deep/ .el-breadcrumb__item {
      span {
        color: #fff;
        font-size: 16px;
        font-weight: normal;
      }
    }
  }
}

.area_cation {
  display: flex;
  justify-content: center;

  /deep/ .el-tabs {
    width: 100%;

    .el-tabs__header {
      height: 60px;
      line-height: 60px;
      background: #4b4b4b;
      border: 0;
      // width: 1200px;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;

      .el-tabs__nav-wrap {
        height: 100%;
        margin-bottom: 0;

        .el-tabs__nav-scroll {
          height: 100%;

          .el-tabs__nav {
            height: 100%;
            border: 0;

            .el-tabs__item {
              height: 100%;
              color: #979797;
              border-left: none;
              border-bottom: none;
              padding: 0 25px;
              line-height: unset;
              font-size: 16px;
            }

            .is-active {
              background: #646464;
            }
          }
        }
      }
    }
  }
}

.zp_wrap {
  width: 1200px;
  height: auto;
  margin: 50px auto;
  text-align: center;

  h2 {
    color: #323232;
    font-weight: normal;
    margin-bottom: 30px;
    font-size: 30px;
  }

  p {
    color: #777777;
    font-size: 18px;
    line-height: 1.8;
    text-align: justify;
    text-align-last: center;
  }
}

.cp_one {
  width: 1300px;
  margin: 60px auto 60px;
  display: flex;
  justify-content: space-between;

  .dynamic_btn {
    // margin-top: 24px;
  }
}

.one_tit {
  display: flex;
  align-items: center;
  color: #003359;
  font-size: 26px;

  img {
    margin-right: 20px;
    width: 44px;
    height: 44px;
  }
}

.one_ul {
  overflow: hidden;
  height: 390px;

  .one_li,
  .li_line {
    width: 100%;
    display: flex;
    border-bottom: 1px solid #5b5b5b;
    align-items: center;
    margin: 20px 0;
    padding-bottom: 15px;
    justify-content: space-between;
    cursor: pointer;

    .menu_single {
      width: 5px;
      height: 5px;
      width: 18px;
      height: 18px;
      // border-radius: 50%;
      margin-right: 20px;
      margin-right: 10px;
      // background: #848484;
    }

    .menu_single img {
      width: 100%;
      height: 100%;
      vertical-align: baseline;
    }

    img {
      width: 20px;
      vertical-align: bottom;
    }
  }
}

.dynamic_btn {
  width: 140px;
  height: 45px;
  margin-top: 50px;
  background: #e8363e;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;

  .more_btn {
    width: 40px;
    margin-left: 10px;
  }
}

.dynamic_btn:hover {
  cursor: pointer;
}

.cp_two {
  width: 100%;
  height: auto;
  // padding: 10px 0 50px 0;

  .two_fir {
    width: 1300px;
    margin: 0 auto;
    padding: 60px 0;
    display: flex;
    justify-content: space-between;

    .two_bg {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 600px;
      height: 530px;
      overflow: hidden;
    }

    .two_bg img {
      width: 100%;
      object-fit: contain;
    }
  }
}

// .xc_wrap {
//   width: 1200px;
//   height: auto;
//   margin: 50px auto;

//   ul {
//     width: 1200px;
//     flex-wrap: wrap;
//     display: flex;
//     justify-content: space-around;
//   }

//   li {
//     width: calc(1200px / 3 - 20px);
//     height: auto;
//     background: #f5f5f5;
//     margin: 30px 0;

//     .n_img__box {
//       overflow: hidden;
//       width: 100%;
//       height: 280px;
//     }

//     .n_img {
//       transform: scale(0.5);
//     }

//     .xc_wrap__title {
//       height: 50px;
//       color: #333;
//       font-size: 16px;
//       font-weight: 500;
//       letter-spacing: 1px;
//       margin: 30px 30px 10px;
//       line-height: 1.5;
//       text-align: justify;
//     }

//     .dynamic_time {
//       margin: 0 30px 0;
//     }

//     .xc_wrap__time {
//       padding-right: 2px;
//       color: #777;
//       font-size: 14px;
//     }

//     .xc_wrap__cate {
//       color: #003258;
//       font-size: 16px;
//     }

//     .dynamic_btn {
//       width: 140px;
//       height: 45px;
//       margin: 20px 0 20px 30px;
//       background: #e8363e;
//       color: #fff;
//       display: flex;
//       align-items: center;
//       justify-content: center;
//       font-size: 14px;

//       .more_btn {
//         width: 40px;
//         margin-left: 10px;
//       }
//     }
//   }
// }

// .sc_pagi {
//   width: 500px;
//   margin: auto;
// }

.area_every {
  width: 100%;
  height: auto;
}

.it_line {
  width: 100%;
  height: 2px;
}

.area_li {
  padding: 35px 0;
  border-bottom: 2px solid #ddd;

  .area_wrap {
    display: flex;
    height: 515px;
    width: 1200px;
    margin: auto;
  }

  img {
    width: 50%;
  }

  .li_right {
    width: 50%;
    // padding: 0 50px;

    h2 {
      color: #003258;
      font-weight: normal;
      margin: 110px 0 30px 110px;
    }

    p {
      // width: 60%;
      color: #777777;
      line-height: 1.8;
      font-size: 16px;
      text-align: justify;
      margin-left: 110px;
    }

    .dynamic_btn {
      width: 140px;
      height: 45px;
      background: #e8363e;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      margin: 40px 0 0 110px;

      .more_btn {
        width: 40px;
        margin-left: 10px;
      }
    }
  }

  .li_left {
    width: 50%;

    .left_box {
      float: right;
      margin-right: 110px;
    }

    h2 {
      color: #003258;
      font-weight: normal;
      margin: 110px 0 30px 0;
    }

    p {
      width: 500px;
      color: #777777;
      line-height: 1.8;
      font-size: 16px;
      text-align: justify;
    }

    .dynamic_btn {
      width: 140px;
      height: 45px;
      background: #e8363e;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      margin: 40px 0 0 0;

      .more_btn {
        width: 40px;
        margin-left: 10px;
      }
    }
  }
}

.fa_two {
  width: 100%;
  height: auto;
  background-color: #f5f5f5;
  padding: 20px 0;

  .two_top {
    width: 1200px;
    margin: 30px auto;
    display: flex;
    flex-wrap: wrap;

    span {
      margin: 10px 30px;
      width: 180px;
      height: 140px;
      padding-top: 20px;
      text-align: center;
      transition: all 0.3s linear;
    }

    span:hover {
      cursor: pointer;
      height: 140px;
      padding-top: 20px;
      box-shadow: 0px 0px 8px 3px #eaeaea;
    }
  }

  .fa_two-icon {
    width: 60px;
    height: 60px;
    margin-bottom: 10px;
  }
}

// .el-tabs__nav-wrap {
//   margin-bottom: 0;
// }

// .el-tabs--card > .el-tabs__header .el-tabs__nav {
//   border: 0;
// }

// .el-tabs--card > .el-tabs__header {
//   border: 0;
//   width: 670px;
//   margin: auto;
// }

// .el-tabs--card > .el-tabs__header .el-tabs__item {
//   border-left: 0;
//   border-bottom: 0;
// }

// .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
//   background: #646464;
// }

// .el-tabs--top.el-tabs--card > .el-tabs__header .el-tabs__item:nth-child(2) {
//   padding-left: 50px;
// }

// .el-tabs--top.el-tabs--card > .el-tabs__header .el-tabs__item:last-child {
//   padding-right: 50px;
// }

// .el-tabs__item {
//   height: 40px;
//   color: gray;
//   padding: 0 50px;
// }

// .el-tabs__item.is-active {
//   color: white;
// }

// .el-tabs__nav-wrap {
//   height: 40px;
// }

// .el-tabs__item:hover {
//   color: gray;
// }

// .el-tabs--card > .el-tabs__header .el-tabs__item.is-active:hover {
//   color: white;
// }

// .el-pagination.is-background .el-pager li:not(.disabled).active {
//   background-color: #e8363e;
// }
.xc_wrap {
  width: 1200px;
  height: auto;
  min-height: 50vh;
  margin: 50px auto;

  .grid-item {
    overflow: hidden;
    width: calc(1200px / 3 - 40px);
    height: auto;
    background: #f5f5f5;
    margin-right: 30px;
    margin-bottom: 20px;
    display: inline-block;
    border-radius: 8px;

    &:hover {
      box-shadow: 0 0 10px 0px rgba($color: #000000, $alpha: 0.2);
      // transform: scale(1.025);
    }

    .n_img {
      display: block;
      width: 100%;
      height: auto;
    }

    .news_title {
      line-height: 1.6;
      margin-top: 18px;
      padding: 0 20px;
      font-size: 18px;
      color: var(--main-color-blue);
      font-weight: 500;
      display: -webkit-box;
      -webkit-line-clamp: 2; /* 显示的行数 */
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-align: justify;
    }

    .dynamic_time {
      margin-left: 30px;
      font-size: 14px;

      span:first-child {
        color: #999;
      }

      span:last-child {
        color: #003359;
        margin-left: 10px;
      }
    }

    .create-time {
      margin: 32px 0 18px;
      padding: 0 20px;
      font-size: 17px;
      font-weight: 300;
      color: var(--main-color-blue);
      color: #666;
    }

    .dynamic_btn {
      width: 140px;
      height: 45px;
      margin: 0 0 20px 20px;
      background: #e8363e;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;

      .more_btn {
        width: 40px;
        margin-left: 10px;
      }
    }
  }

  .grid-item:nth-child(3n) {
    margin-right: 0;
  }

  .sign_wrap {
    width: 320px;
    height: auto;
    padding: 30px 15px 30px 25px;
    background: #003359;

    .sign_title {
      font-size: 16px;
      color: #a5a5a5;
    }

    .sign_list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      font-size: 14px;
      color: #fff;
      margin-top: 20px;

      span {
        margin-right: 10px;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  //   ul {
  //     width: 1200px;
  //     flex-wrap: wrap;
  //     display: flex;
  //     justify-content: space-around;
  //   }

  //   li {
  //     ;
  //     height: auto;
  //
  //     margin: 30px 0;

  //
  //   }
}

.xc_wrap1 {
  width: 1200px;
  height: auto;
  margin: 50px auto;

  .grid-item1 {
    overflow: hidden;
    width: calc(1200px / 3 - 40px);
    height: auto;
    background: #f5f5f5;
    margin-right: 30px;
    margin-bottom: 20px;
    display: inline-block;
    border-radius: 8px;

    &:hover {
      box-shadow: 0 0 10px 0px rgba($color: #000000, $alpha: 0.2);
      // transform: scale(1.025);
    }

    .n_img {
      display: block;
      width: 100%;
      height: auto;
    }

    .news_title {
      line-height: 1.6;
      margin-top: 18px;
      padding: 0 20px;
      font-size: 18px;
      color: var(--main-color-blue);
      font-weight: 500;
      display: -webkit-box;
      -webkit-line-clamp: 2; /* 显示的行数 */
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-align: justify;
    }

    .dynamic_time {
      margin-left: 30px;
      font-size: 14px;

      span:first-child {
        color: #999;
      }

      span:last-child {
        color: #003359;
        margin-left: 10px;
      }
    }

    .create-time {
      margin: 32px 0 18px;
      padding: 0 20px;
      font-size: 17px;
      font-weight: 300;
      color: var(--main-color-blue);
      color: #666;
    }

    .dynamic_btn {
      width: 140px;
      height: 45px;
      margin: 0 0 20px 20px;
      background: #e8363e;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;

      .more_btn {
        width: 40px;
        margin-left: 10px;
      }
    }
  }

  .grid-item:nth-child(3n) {
    margin-right: 0;
  }

  .sign_wrap {
    width: 320px;
    height: auto;
    padding: 30px 15px 30px 25px;
    background: #003359;

    .sign_title {
      font-size: 16px;
      color: #a5a5a5;
    }

    .sign_list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      font-size: 14px;
      color: #fff;
      margin-top: 20px;

      span {
        margin-right: 10px;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }

  //   ul {
  //     width: 1200px;
  //     flex-wrap: wrap;
  //     display: flex;
  //     justify-content: space-around;
  //   }

  //   li {
  //     ;
  //     height: auto;
  //
  //     margin: 30px 0;

  //
  //   }
}

.sc_pagi {
  width: 500px;
  margin: 0 auto 50px;
  display: flex;
  justify-content: center;

  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #e8363e;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cpProgram/cpProgram.vue